// @flow

import React from 'react'
import styled, { keyframes } from 'styled-components'
import { imagePath } from 'frontend_core/dist/helpers/image'

const RotateAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledImgSpin = styled.img`
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;
  animation: ${RotateAnim};
  animation-duration: 800ms;
  animation-iteration-count: infinite;
  animation-timing-function: ${props => props.easing || 'linear'};
`

type PropTypes = {
  size?: number,
  easing?: string,
}

export default (props: PropTypes) => (
  <StyledImgSpin src={imagePath('event/spm-spin.svg')} {...props} />
)
